import { nonNullable } from '@common/utils/nonNullableTypeUtils';

type UzoviRegisterItem = {
    code: string;
    label: string;
    name: string;
};

/*
 * Based on https://www.vektis.nl/uzovi-register
 * This only contains entries that have been relevant so far, but any entry may be added.
 */
export const uzoviRegister = {
    anderZorg: {
        code: '3333',
        label: 'Anderzorg',
        name: 'Anderzorg N.V.',
    },
    cz: {
        code: '9664',
        label: 'CZ',
        name: 'Centrale Verwerkingseenheid CZ',
    },
    menzis: {
        code: '3332',
        label: 'Menzis',
        name: 'Menzis Zorgverzekeraar N.V.',
    },
    zilverenKruis: {
        code: '3311',
        label: 'Zilveren Kruis',
        name: 'Zilveren Kruis Zorgverzekeringen N.V.',
    },
} as const;

export function findUzoviRegisterItem(code: string): UzoviRegisterItem | undefined {
    return Object.values(uzoviRegister).find((item) => item.code === code);
}

export function getUzoviRegisterItem(code: string): UzoviRegisterItem {
    return nonNullable(findUzoviRegisterItem(code));
}
